import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'

const Contact: React.FC = () => {
  useHubSpotGenerate('na1', '9395227', '491ada07-e8a0-42aa-a802-3dd70375440c', '#sp_hbspt')

  return (
    <section className={styles.contact} id="contact">
      <span className={styles.title}>お問い合わせ</span>
      <div className="frontend_hubSpot backend_hubSpot" id="sp_hbspt"></div>
    </section>
  )
}

export default Contact
